import { FileType } from '../../../constants';

export const attachmentSupportedFileTypes = [FileType.PDF, FileType.PNG, FileType.JPEG, FileType.JPG];
export const aiAttachmentUploaderMaxCount = 5;

export const packagesSheetName = 'Packages';
export const treatmentsSheetName = 'Treatments';
export const itemsSheetName = 'Items';

export const preferedItemsModeKey = 'ItemsMode';

export enum TableMode {
  Table = 'Table',
  List = 'List',
}
